<template>
  <div class="appIndex">
    <div class="side"></div>
    <div class="pages">
      <router-view />
    </div>
    <div class="side"></div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  onBeforeUnmount,
  nextTick,
} from "vue";
import { useCounterStore } from "@/store";
import { useInviteStore } from "@/store/invite";
import { useRoute, useRouter } from "vue-router";
import { getOpen } from "@/api/home";
import { appDeteil } from "@/api/text";
import { getToken, getEquipment, setEquipment } from "@/ulits/auth";

/**
 * 仓库
 */
const store = useCounterStore();
const invitrStore = useInviteStore();
store.getWxFlag();
store.copywritingTrue();
// setInterval(function() {
//   check()
// }, 100);
// const check = () =>{
//   function doCheck(a) {
//     if (("" + a/a)["length"] !== 1 || a % 20 === 0) {
//       (function() {}
//       ["constructor"]("debugger")())
//     } else {
//       (function() {}
//       ["constructor"]("debugger")())
//     }
//     doCheck(++a)
//   }
//   try {
//     doCheck(0)
//   } catch (err) {}
// };
// check();
/**
 * 路由对象
 */

const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
/**
 * 数据部分
 */
setTimeout(() => {
  if (
    localStorage.getItem("userInfo") &&
    getToken() &&
    route.name !== "appPay"
  ) {
    let info = JSON.parse(localStorage.getItem("userInfo"));
    store.getUserinfo(info.id);
  }
});
const data = reactive({});
data.getCode = () => {
  const openid = localStorage.getItem("openid");
  const params = new URLSearchParams(location.search);
  const result = {};
  setTimeout(() => {
    let params = new URL(document.location).searchParams;
    let param1 = params.get("invite_code");
    if (route.query.invite_code || param1) {
      sessionStorage.setItem("nviteCode", route.query.invite_code || param1);
    }
  });
  for (let param of params) {
    result[param[0]] = param[1];
  }
  if (result.code || openid) {
    if (result.state) {
      sessionStorage.setItem("nviteCode", result.state);
    }
    if (result.code && !openid) {
      getOpen({ code: result.code }).then((res) => {
        if (res.code === 200) {
          localStorage.setItem("openid", res.data.openid);
        }
      });
    }
  } else {
    if (process.env.NODE_ENV === "production") {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf30ed3615020811d&redirect_uri=https://www.aibene.cn/&response_type=code&scope=snsapi_base&connect_redirect=1&state=${
        route.query.invite_code ? route.query.invite_code : ""
      }#wechat_redirect`;
    } else {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf30ed3615020811d&redirect_uri=https://fairy-web-test.aibene.cn/&response_type=code&scope=snsapi_base&connect_redirect=1&state=${
        route.query.invite_code ? route.query.invite_code : ""
      }#wechat_redirect`;
    }
  }
};

data.saveData = () => {
  let params = {
    generate: store.generate,
    copywriting: store.copywriting,
    createFlag: store.createFlag,
    inviteShow: invitrStore.inviteShow,
  };
  sessionStorage.setItem("savedData", JSON.stringify(params));
};

onBeforeMount(() => {});
onMounted(() => {
  if (!getEquipment()) {
    setEquipment();
  }
  if (store.WxFlage) {
    if (process.env.NODE_ENV !== "dev") {
      data.getCode();
    }
  } else {
    setTimeout(() => {
      let params = new URL(document.location).searchParams;
      let param1 = params.get("invite_code");
      if (route.query.invite_code || param1) {
        sessionStorage.setItem("nviteCode", route.query.invite_code || param1);
      }
    });
  }
  const storedData = sessionStorage.getItem("savedData");
  if (storedData) {
    store.setGenerate(JSON.parse(storedData).generate);
    store.setCreateFlag(JSON.parse(storedData).createFlag);
    invitrStore.setInviteShow(JSON.parse(storedData).inviteShow);
    if (JSON.parse(storedData).copywriting && route.path !== "/appliance") {
      store.copywritingTrue();
    } else {
      store.copywritingFalse();
    }
    if (route.path === "/appliance") {
      store.setGenerate(JSON.parse(storedData).generate);
    } else {
      store.setGenerate(true);
    }
  }
});
watchEffect(() => {
  let params = new URL(document.location).searchParams;
  let param1 = params.get("id");
  if (param1) {
    appDeteil({ app_id: Number(param1) }).then((res) => {
      store.setAppInfo(res.data);
      localStorage.setItem("category_id", res.data.category[0].id);
      localStorage.setItem("appInfo", JSON.stringify(res.data));
      data.appInfo = res.data;
      document.title = route.path === "/appliance"? data.appInfo.name + " — 花集AI精灵" :route.meta.title  + " — 花集AI精灵"
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute(
          "content",
          "花集AI精灵 " +
            (data.appInfo ? data.appInfo.name : route.meta.keywords) ||
            "花集AI精灵"
        );
      } else {
        const meta = document.createElement("meta");
        meta.name = "keywords";
        meta.content =
          "花集AI精灵 " +
            (data.appInfo ? data.appInfo.name : route.meta.keywords) ||
          "花集AI精灵";
        document.getElementsByTagName("head")[0].appendChild(meta);
      }
      const metaDescription = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescription) {
        metaDescription.setAttribute("content", data.appInfo.intro);
      } else {
        const meta = document.createElement("meta");
        meta.name = "description";
        meta.content = data.appInfo.intro;
        document.getElementsByTagName("head")[0].appendChild(meta);
      }
    });
  } else {
    data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
    document.title = route.path === "/appliance"? data.appInfo.name + " — 花集AI精灵" :route.meta.title  + " — 花集AI精灵"
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "花集AI精灵 " +
          (data.appInfo ? data.appInfo.name : route.meta.keywords) ||
          "花集AI精灵"
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "keywords";
      meta.content =
        "花集AI精灵 " +
          (data.appInfo ? data.appInfo.name : route.meta.keywords) ||
        "花集AI精灵";
      document.getElementsByTagName("head")[0].appendChild(meta);
    }
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        data.appInfo ? data.appInfo.intro : "首页"
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = data.appInfo ? data.appInfo.intro : "首页";
      document.getElementsByTagName("head")[0].appendChild(meta);
    }
  }
});

onBeforeUnmount(() => {
  localStorage.removeItem("code");
});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style>
body {
  margin: 0;
  padding: 0;
  background: #111525;
  overflow: hidden;
}
::v-deep().bottomOverlay {
  background: #000;
}

:root {
  --van-toast-font-size: 30px !important;
  --van-toast-default-width: 220px !important;
  --van-toast-default-min-height: 220px !important;
  --van-padding-xs: 20px !important;
  --van-toast-line-height: 35px !important;
  --textHeader: 0px;
}
</style>
<style lang="scss">
.popoverTip {
  .van-popover__arrow {
    color: #323233 !important;
  }
  .van-popover__content {
    background: transparent !important;
  }
}
</style>

<style lang="scss" scoped>
::v-deep().exchangePopupClass {
  .van-popup__close-icon {
    font-size: 48px;
  }
  .codeInput {
    margin-top: 100px;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
    padding: 0 30px;
    .van-field {
      flex: 1;
      font-size: 30px;
      padding: 23px 39px;
      background: #eeeeee;
      border-radius: 24px;
      .van-field__control {
        color: black !important;
      }
    }
    .codeBtn {
      margin-left: 60px;
      width: 186px;
      padding: 20px;
      background: #8368fc;
      border-radius: 24px;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
    }
  }
  .title {
    padding-top: 40px;
    text-align: center;
    font-weight: 400;
    color: #222222;
  }
}
</style>
